import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './_layout';
import ProtectedRoute from './AirSearch/ProtectedRoute';
import Index from './AirSearch/Index';
import Tickets from './AirSearch/Tickets';
import AirResponse from './AirResponse/Index';
import FareDetails from "./AirSearch/Faredetails";
import FlightReview from "./AirResponse/FlightReview";
import PaymentSuccess from "./AirResponse/PaymentSuccess";     
import Ticket from "./AirSearch/Tickets";            
import ProfilePage from "./Account/MyProfile";
import HotelSearchEngine from "./Hotel/Index";
import HotelResults from "./Hotel/HotelResults"; 
import PaymentFailure from "./AirResponse/Paymentfailure";
import AboutUs from "./AirSearch/About";
import ResetPassword from "./AirSearch/ResetPassword";
import HotelDetails from "./Hotel/HotelDetails";
import HotelReview from "./Hotel/HotelReview.jsx";
import HotelTicket from "./Hotel/HotelTicket";
import HotelBookings from "./Hotel/Hotelbooking.jsx";
import FlightBookings from "./AirResponse/Flightbooking.jsx";
import UserTicket  from "./UserTicket";   
const MyBookings = () => <div style={{ padding: '40px', textAlign: 'center' }}><h1>My Bookings</h1><p>Bookings page - Login required</p></div>;
const Deposit = () => <div style={{ padding: '40px', textAlign: 'center' }}><h1>Deposit</h1><p>Deposit page - Login required</p></div>;
const BankDetails = () => <div style={{ padding: '40px', textAlign: 'center' }}><h1>Bank Details</h1><p>Bank details page - Login required</p></div>;

function HomePage({ userSession, setUserSession, activeTab, setActiveTab }) {
  return (
    <Layout  userSession={userSession}  activeTab={activeTab} setActiveTab={setActiveTab}  onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession} >
      <Index activeTab={activeTab} setActiveTab={setActiveTab} />
    </Layout>
  );
}

function TicketsPage({ userSession, setUserSession }) {
  return (
    <Layout userSession={userSession} activeTab="flight" setActiveTab={() => {}} onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession} >
      <Tickets />
    </Layout>
  );
}

function AirResponsePage({ userSession, setUserSession }) {
  return (
    <Layout  userSession={userSession} activeTab="flight" setActiveTab={() => {}}  onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession} >
      <AirResponse />
    </Layout>
  );
}

function HotelPage({ userSession, setUserSession }) {
   console.log("Layout:", Layout);
  console.log("HotelSearchEngine:", HotelSearchEngine);
  return (
    <Layout  userSession={userSession} activeTab="hotel" setActiveTab={() => {}}  onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession} >
      <HotelSearchEngine />
    </Layout>
  );
}
function FareDetailsPage({ userSession, setUserSession }) {
  return (
    <Layout  userSession={userSession} activeTab="flight" setActiveTab={() => {}}  onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession} >
      <FareDetails />
    </Layout>
  );
}

function FlightReviewPage({ userSession, setUserSession }) {
  return (
    <Layout  userSession={userSession}  activeTab="flight"  setActiveTab={() => {}}  onLoginClick={() => alert("Login modal open karo")}  onLoginSuccess={setUserSession} >
      <FlightReview />
    </Layout>
  );
}

function PaymentSuccessPage({ userSession, setUserSession }) {
  return (
    <Layout  userSession={userSession}  activeTab="flight"  setActiveTab={() => {}}  onLoginClick={() => alert("Login modal open karo")}  onLoginSuccess={setUserSession} >
      <PaymentSuccess userSession={userSession} />
    </Layout>
  );
}
function HotelReviewPage({ userSession, setUserSession }) {
  return (
    <Layout userSession={userSession} activeTab="hotel" setActiveTab={() => {}}
      onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession}>
      <HotelReview setUserSession={setUserSession} userSession={userSession} />
    </Layout>
  );
}
function TicketPage({ userSession, setUserSession }) {
  return (
    <Layout  userSession={userSession}  activeTab="flight"  setActiveTab={() => {}}  onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession}>
      <Ticket userSession={userSession} />
    </Layout>
  );
}

function MyProfilePage({ userSession, setUserSession }) {
  return (
    <Layout userSession={userSession} activeTab="" setActiveTab={() => {}} onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession}>
      <ProtectedRoute userSession={userSession}>
        <ProfilePage userSession={userSession} />
      </ProtectedRoute>
    </Layout>
  );
}

function MyBookingsPage({ userSession, setUserSession }) {
  return (
    <Layout userSession={userSession} activeTab="" setActiveTab={() => {}}  onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession} >
      <ProtectedRoute userSession={userSession}>
        <MyBookings />
      </ProtectedRoute>
    </Layout>
  );
}

function DepositPage({ userSession, setUserSession }) {
  return (
    <Layout userSession={userSession} activeTab="" setActiveTab={() => {}} onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession} >
      <ProtectedRoute userSession={userSession}>
        <Deposit />
      </ProtectedRoute>
    </Layout>
  );
}
function HotelResultsPage({ userSession, setUserSession }) {
  return (
    <Layout userSession={userSession} activeTab="hotel"  setActiveTab={() => {}}onLoginClick={() => alert("Login modal open karo")}onLoginSuccess={setUserSession} >
      <HotelResults />
    </Layout>
  );
}
function HotelDetailsPage({ userSession, setUserSession }) {
  return (
    <Layout 
      userSession={userSession} 
      activeTab="hotel" 
      setActiveTab={() => {}} 
      onLoginClick={() => alert("Login modal open karo")} 
      onLoginSuccess={setUserSession}
    >
      <HotelDetails />
    </Layout>
  );
}
function BankDetailsPage({ userSession, setUserSession }) {
  return (
    <Layout userSession={userSession} activeTab=""  setActiveTab={() => {}}onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession} >
      <ProtectedRoute userSession={userSession}>
        <BankDetails />
      </ProtectedRoute>
    </Layout>
  );
}
function AboutUsPage({ userSession, setUserSession }) {
  return (
    <Layout>
      <ProtectedRoute userSession={userSession}>
        <AboutUs/> 
      </ProtectedRoute>
     </Layout>
  );
}
function PaymentFailurePage({ userSession, setUserSession }) {
  return (
    <Layout userSession={userSession} activeTab="flight" setActiveTab={() => {}} onLoginClick={() => alert("Login modal open karo")} onLoginSuccess={setUserSession}>
      <PaymentFailure />
    </Layout>
  );
}
function HotelTicketPage({ userSession, setUserSession }) {
  return (
    <Layout
      userSession={userSession}
      activeTab="hotel"
      setActiveTab={() => {}}
      onLoginClick={() => alert("Login modal open karo")}
      onLoginSuccess={setUserSession}
    >
      <HotelTicket />
    </Layout>
  );
}
function NotFoundPage() {
  return (
    <Layout   userSession={null} activeTab=""setActiveTab={() => {}} onLoginClick={() => alert("Login modal open karo")} >
      <div style={{ padding: "40px", textAlign: "center", minHeight: "60vh", display: "flex", alignItems: "center",  justifyContent: "center"   }}>
        <div>
          <h1 style={{ fontSize: "48px", fontWeight: "bold", margin: "0 0 20px 0" }}>404</h1>
          <p style={{ fontSize: "18px", color: "#666", margin: 0 }}>Page not found</p>
          <p style={{ fontSize: "14px", color: "#999", margin: "10px 0 0 0" }}>Sorry, the page you're looking for doesn't exist.</p>
        </div>
      </div>
    </Layout>
  );
}
function UserTicketPage({ userSession, setUserSession }) {
  return (
    <Layout
      userSession={userSession}
      activeTab="hotel"
      setActiveTab={() => {}}
      onLoginClick={() => alert("Login modal open karo")}
      onLoginSuccess={setUserSession}
    >
      <UserTicket />
    </Layout>
  );
}
function App() {
  const [activeTab, setActiveTab] = useState("flight");
  const [userSession, setUserSession] = useState(null);
  useEffect(() => {
    const savedData = localStorage.getItem("userData");
    if (savedData) {
      try {
        setUserSession(JSON.parse(savedData));
      } 
      catch (err) {
        console.error("Saved session data corrupt hai, clearing it:", err);
        localStorage.removeItem("userData");
        localStorage.removeItem("userKey");
      }
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route  path="/" element={ <HomePage activeTab={activeTab} setActiveTab={setActiveTab} userSession={userSession} setUserSession={setUserSession} /> } />
        <Route  path="/tickets" element={<TicketsPage userSession={userSession} setUserSession={setUserSession} />} />
        <Route  path="/AirResponse/Index" element={<AirResponsePage userSession={userSession} setUserSession={setUserSession} />} />
        <Route path="/FareDetails" element={<FareDetailsPage userSession={userSession} setUserSession={setUserSession} />}/>
        <Route path="/FlightReview" element={<FlightReviewPage userSession={userSession} setUserSession={setUserSession} />}  />
        <Route path="/payment-success" element={<PaymentSuccessPage userSession={userSession} setUserSession={setUserSession} />} />
        <Route path="/PaymentSuccess" element={<PaymentSuccessPage userSession={userSession} setUserSession={setUserSession} />} />
        <Route path="/ticket-details" element={<TicketPage userSession={userSession} setUserSession={setUserSession} />}/>
        <Route path="/myprofile" element={<MyProfilePage userSession={userSession} setUserSession={setUserSession} />} /> 
        <Route path="/flightbookings" element={<MyBookingsPage userSession={userSession} setUserSession={setUserSession} />} />
        <Route  path="/deposit" element={<DepositPage userSession={userSession} setUserSession={setUserSession} />} />
        <Route  path="/bank-details" element={<BankDetailsPage userSession={userSession} setUserSession={setUserSession} />}  />
        <Route  path="/hotel"  element={<HotelPage userSession={userSession} setUserSession={setUserSession} />}/>
        <Route  path="/hotel-results"  element={<HotelResultsPage userSession={userSession} setUserSession={setUserSession} />}/>
        <Route path="/hotel-details/:tripId" element={<HotelDetailsPage userSession={userSession} setUserSession={setUserSession} />} />
     <Route path="/hotel-review" element={<HotelReviewPage userSession={userSession} setUserSession={setUserSession} />} />
        <Route path="/hotel-ticket" element={<HotelTicketPage userSession={userSession} setUserSession={setUserSession} />} />
        <Route path="/payment-failure" element={<PaymentFailurePage userSession={userSession} setUserSession={setUserSession} />} />
        <Route path="/about-us" element={<AboutUsPage userSession={userSession} setUserSession={setUserSession} />} />
        <Route path="/hotel-bookings" element={<HotelBookings userSession={userSession} />} />
         <Route path="/flight-bookings" element={<FlightBookings userSession={userSession} />} />
<Route path="/user-ticket" element={<UserTicketPage userSession={userSession} setUserSession={setUserSession} />} />         <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*"  element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;